import { render, staticRenderFns } from "./settingCompanyGeneral.vue?vue&type=template&id=08121b95&scoped=true&"
import script from "./settingCompanyGeneral.vue?vue&type=script&lang=js&"
export * from "./settingCompanyGeneral.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyGeneral.vue?vue&type=style&index=0&id=08121b95&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08121b95",
  null
  
)

export default component.exports